import type { IntlShape } from "react-intl";
import type InputType from "../../Input/InputType";
import { JsonInputType } from "../../Input/JsonInputType";
import { SideName } from "../../Side/SideName";
import Plate from "../Plate";

export default class Heart extends Plate {
	public static code = "plate_heart";

	public getDimensionsString(input: InputType, intl: IntlShape) {
		const { width } = this.formatInputs(input, intl);
		if (width) {
			return intl.formatMessage({ defaultMessage: "Hoogte {width}" }, { width });
		}

		return undefined;
	}

	public calculateSideLength(side: SideName, input: InputType) {
		const height = Number(input[JsonInputType.Width]);

		if (!Number.isNaN(height)) {
			switch (side) {
				case SideName.Length1:
					return (2 + Math.PI) * (height / ((3 / 4) * Math.sqrt(2) + 1 / 2));
			}
		}

		return undefined;
	}

	public calculateSheetDimensions(input: InputType): { length: number; width: number } | undefined {
		const width = Number(input[JsonInputType.Width]);

		if (!Number.isNaN(width)) {
			return { length: width, width };
		}
	}

	protected calculateMaxBeltSize(data: Record<JsonInputType, number>) {
		return super.calculateMaxBeltSize({
			[JsonInputType.Length]: data.width,
			[JsonInputType.Width]: data.width / ((3 / 4) * Math.sqrt(2) + 1 / 2),
		} as Record<JsonInputType, number>);
	}
}
